import React from 'react';
import { useNavigate } from '@tanstack/react-router';
import { useDeleteTask } from '../../api/tasks';
import { PleriModal } from '../common/PleriModal/PleriModal';
import { Button } from '@plerionhq/design-system';
import { DEFAULT_TASK_TYPE } from '../../pages/tasks/utils';

import { useTranslation } from 'react-i18next';

interface DeleteTaskModalProps {
  isOpen: boolean;
  taskId: string;
  taskName: string;
  onClose: () => void;
}

export const DeleteTaskModal: React.FC<DeleteTaskModalProps> = ({
  isOpen,
  taskId,
  taskName,
  onClose,
}) => {
  const { t } = useTranslation('pleri/chat');
  const navigate = useNavigate();
  const { mutateAsync: deleteTask, isPending: isDeleting } =
    useDeleteTask(DEFAULT_TASK_TYPE);

  const confirmDeleteTask = () => {
    deleteTask(taskId).finally(() => {
      onClose();
      navigate({ to: '/tasks' });
    });
  };

  return (
    <PleriModal
      isOpen={isOpen}
      title={t('deleteTask')}
      onClose={onClose}
      size="sm"
    >
      <div className="space-y-4">
        <p className="text-sm text-gray-600 dark:text-gray-400">
          {t('areYouSureYouWantToDelete', { taskName })}
        </p>
        <div className="flex justify-end space-x-3">
          <Button
            variant="secondary"
            label={t('common:cancel')}
            data-testid="cancel-delete-task"
            onClick={onClose}
            isDisabled={isDeleting}
            size="small"
          />
          <Button
            label={isDeleting ? t('deleting') : t('common:delete')}
            data-testid="confirm-delete-task"
            onClick={confirmDeleteTask}
            isDisabled={isDeleting}
            variant="primary"
            size="small"
          />
        </div>
      </div>
    </PleriModal>
  );
};
